import React, { useEffect, useState } from "react";
import axios from "axios";
import "draft-js-mention-plugin/lib/plugin.css";
import "draft-js/dist/Draft.css";
import { useFormik } from "formik";
import { useHistory } from "react-router";
import Select from "react-select";
import Swal from "sweetalert2";
import { usePermissionGuardRedirect } from "../../../hooks/usePermissionGuard";
import {
  getWhatsappItems,
  updateWhatsappItems
} from "../../../services/WhatsappService";
import PermissionsGate from "../../../utils/permissionGate";

const byDayOptions = [{ value: 0, label: "Hours" }, { value: 1, label: "Days" }]
const requireFirstNameOptions = [{ value: 1, label: "Yes" }, { value: 0, label: "No" }]
const typeOptions = [{ value: "rereg", label: "Re-Registration & Articulation nurturing" }, { value: 'files', label: "File Request Nurturing" }]
const ReRegNurturingEdit = () => {
  const [type, setType] = useState("rereg");
  const history = useHistory();
  const [details, setDetails] = useState([]);
  const [loading, setloading] = useState(false);

  usePermissionGuardRedirect(['wanview']);

  useEffect(() => {
    setloading(true);
    const dropdownSource = axios.CancelToken.source();
    const fetchData = async () => {
      try {
        const res = await getWhatsappItems(type, dropdownSource.token);
        if (res.status == 200) {
          setDetails(res?.data?.items ?? []);
          setloading(false);
        };
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
          setloading(false);
        }
      }
    };
    fetchData();
    return () => {
      dropdownSource.cancel('Component unmounted');
    };
  }, [type])
  const formik = useFormik({
    initialValues: {
      items: details?.length > 0 ? details : [],
    },
    onSubmit: () => {
      setloading(true);
      updateWhatsappItems({ items: details, type: type })
        .then((res) => {
          if (res.status === 200) {
            Swal.fire({
              icon: "success",
              title: res?.data?.message ?? "Done",
              text: "Data updated successfully",
              confirmButtonText: "OK",
            }).then(() => {
              // refresh page
              window.location.reload();
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: res?.message,
              confirmButtonText: "OK",
            })
          }
        })
        .catch((err) => {
          console.log("error", err);
          Swal.fire({ icon: "error", title: "Error", text: err?.response?.data?.message ?? "Something went wrong" });
        })
        .finally(() => {
          setloading(false);
        });
    }
  });
  return (
    <>
      <div className="card card-body-inr">
        <div className="edit-icon new-card-header">
          <div className="card-header">Whatsapp Templates</div>{loading && <>{" "}<i className="fas fa-cog fa-spin"></i></>}
        </div>
        <p>The items below will be sent in the order shown. Each item will be sent after specified period ("Send after") after previous item was sent</p>
        <Select
          name="type"
          value={typeOptions.find((option) => option.value === type)}
          options={typeOptions}
          onChange={(e) =>
            setType(e.value)
          }
        />
        <div className="card-body-inr card-body-info">
          <form onSubmit={formik.handleSubmit}>
            <hr />
            {details?.length > 0 ? (
              details.map((item, index) => {
                return (
                  <React.Fragment key={index}>
                    <div className="row mb-3">
                      <div className="col-md-3" >
                        <div className="form-icon-group" style={{ display: 'block' }}>
                          <label>Name *</label>
                          <input
                            required
                            className={"form-control"}
                            type="text"
                            name={`name_${index}`}
                            id={`name_${index}`}
                            placeholder="Name"
                            title="Name"
                            value={item.name}
                            onChange={(e) => {
                              const value = e.target.value;
                              return setDetails((prevDetails) => {
                                const updatedDetails = [...prevDetails];
                                updatedDetails[index] = {
                                  ...updatedDetails[index],
                                  name: value,
                                };
                                return updatedDetails;
                              })
                            }
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-3" >
                        <div className="form-icon-group" style={{ display: 'block' }}>
                          <label>FB Template_name *</label>
                          <input
                            required
                            className={"form-control"}
                            type="text"
                            name={`template_name_${index}`}
                            id={`template_name_${index}`}
                            placeholder="template_name"
                            title="template_name"
                            value={item.template_name}
                            onChange={(e) => {
                              const value = e.target.value;
                              return setDetails((prevDetails) => {
                                const updatedDetails = [...prevDetails];
                                updatedDetails[index] = {
                                  ...updatedDetails[index],
                                  template_name: value,
                                };
                                return updatedDetails;
                              })
                            }
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-1" >
                        <div className="form-icon-group " style={{ display: 'block' }}>
                          <label>Send after *</label>
                          <input
                            required
                            className={"form-control"}
                            type="number"
                            name={`time_${index}`}
                            id={`time_${index}`}
                            placeholder="time"
                            title="time"
                            value={item.time}
                            onChange={(e) => {
                              const value = e.target.value;
                              return setDetails((prevDetails) => {
                                const updatedDetails = [...prevDetails];
                                updatedDetails[index] = {
                                  ...updatedDetails[index],
                                  time: Number(value),
                                };
                                return updatedDetails;
                              })
                            }
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-2" >
                        <div className="form-icon-group" style={{ display: 'block' }}>
                          <label>Hours/Days *</label>
                          <Select
                            name={`byDay_${index}`}
                            value={byDayOptions.find((option) => option.value === item.byDay)}
                            options={byDayOptions}
                            onChange={(e) =>
                              setDetails((prev) => {
                                const updated = [...prev];
                                updated[index] = {
                                  ...updated[index],
                                  byDay: Number(e.value),
                                };
                                return updated;
                              })
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-2" >
                        <div className="form-icon-group " style={{ display: 'block' }}>
                          <label>Template Requires Firstname *</label>
                          <Select
                            name={`require_firstname_${index}`}
                            value={requireFirstNameOptions.find((option) => option.value === item.require_firstname)}
                            options={requireFirstNameOptions}
                            onChange={(e) =>
                              setDetails((prev) => {
                                const updated = [...prev];
                                updated[index] = {
                                  ...updated[index],
                                  require_firstname: Number(e.value),
                                };
                                return updated;
                              })
                            }
                          />
                        </div >
                      </div>
                      <div style={{ paddingRight: '15px' }}>
                        <p></p>
                        <PermissionsGate scopes={["wanmodify"]} errorProps={{ disabled: true }}>
                          <button
                            className="btn btn-primary rounded-circle"
                            type="button"
                            onClick={() =>
                              setDetails(prev => {
                                if (index === 0) return prev;
                                const updated = [...prev];
                                [updated[index - 1], updated[index]] = [updated[index], updated[index - 1]];
                                // reset order_no starting from 1
                                return updated.map((item, i) => ({ ...item, order_no: i + 1 }));
                              })
                            }
                          >
                            <i className="fa-light fa-up"></i>
                          </button>
                        </PermissionsGate>
                        <p></p>
                        <PermissionsGate scopes={["wanmodify"]} errorProps={{ disabled: true }}>
                          <button
                            className="btn btn-primary rounded-circle"
                            type="button"
                            onClick={(e) => {
                              e.preventDefault();
                              setDetails(prev => {
                                if (index === prev.length - 1) return prev;
                                const updated = [...prev];
                                [updated[index], updated[index + 1]] = [updated[index + 1], updated[index]];
                                // reset order_no starting from 1
                                return updated.map((item, i) => ({ ...item, order_no: i + 1 }));
                              })
                            }
                            }
                          >
                            <i className="fa-light fa-down"></i>
                          </button>
                        </PermissionsGate>
                      </div>
                      <div className="" >
                        <p></p>
                        <PermissionsGate scopes={["wanmodify"]} errorProps={{ disabled: true }}>
                          <button className="btn btn-danger rounded-circle" title="Delete"
                            onClick={(e) => {
                              // remove from details
                              e.preventDefault();
                              setDetails((prev) => {
                                const updated = [...prev];
                                updated.splice(index, 1);
                                return updated;
                              })
                            }
                            }>
                            <i className="fal fa-trash-alt"></i>
                          </button>
                        </PermissionsGate>
                      </div>
                    </div>
                    <hr />
                  </React.Fragment >
                )
              })
            ) : ""}
            <PermissionsGate
              scopes={["wanmodify"]}
              errorProps={{ disabled: true }}
            >
              <button
                style={{ marginBottom: '15px' }}
                className="btn btn-primary btn-success"
                title="Add Item"
                type="button"
                disabled={loading}
                onClick={(e) => {
                  e.preventDefault();
                  // add item to end of details
                  setDetails((prev) => {
                    const updated = [...prev]
                    updated.push({ order_no: prev.length + 1 });
                    return updated;
                  })
                }
                }
              >
                Add Item
              </button>
            </PermissionsGate>
            <div className="form-group form-group-save-cancel">
              <PermissionsGate
                scopes={["wanmodify"]}
                errorProps={{ disabled: true }}
              >          <button
                className="btn btn-save btn-success"
                type="submit"
                title="Save"
              // disabled={!formik.dirty}
              >
                  {loading ? (
                    <i className="fas fa-cog fa-spin"></i>
                  ) : (
                    <i className="fal fa-save"></i>
                  )}
                  Save
                </button>
              </PermissionsGate>

              <button
                className="btn btn-close btn-danger"
                type="button"
                title="Cancel"
                // onClick={() => history.push("/administration/email/list/table")}
                onClick={() => history.goBack()}
              >
                <i className="fal fa-times"></i>
                Cancel
              </button>
            </div>
          </form >
        </div >
      </div >
    </>
  );
};

export default ReRegNurturingEdit;
